import { render, staticRenderFns } from "./rightNav.vue?vue&type=template&id=b01f58c4&scoped=true"
import script from "./rightNav.vue?vue&type=script&lang=js"
export * from "./rightNav.vue?vue&type=script&lang=js"
import style0 from "./rightNav.vue?vue&type=style&index=0&id=b01f58c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01f58c4",
  null
  
)

export default component.exports